import { useState } from 'react';
import dateFormat from 'date-fns/format';

import DataTable from 'components/CncUI/DataTable';
import Modal from 'components/CncUI/Modal';
import Button from 'components/CncUI/Button';

const LexisLog = props => {
  const { records } = props;
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({ label: '', data: {} });

  const openModal = (label, data) => {
    setModalData({ label, data });
    setOpen(true);
  };

  const modalLink = (label, title, data, rowId) => {
    if (!data) return '';
    return (
      <Button
        onClick={() => openModal(title || label, data)}
        short
        style={{ marginRight: 8 }}
        key={`data-display-${label}-${rowId}`}
      >
        {label}
      </Button>
    );
  };

  const formatDate = timestamp => {
    const date = new Date(parseInt(timestamp, 10));
    return dateFormat(date, 'MM/dd/yyyy HH:mm:ss');
  };

  const formatLexisId = row => {
    return row.data?.business?.data?.BIID20ResponseEx?.response?.Result
      ?.CompanyResults?.BusinessIds?.SeleID;
  };

  const formatBusinessStatus = row => {
    return JSON.stringify(row.data?.user?.valid) ? 'Valid' : 'Invalid';
  };

  const formatProcessStatus = row => {
    return row.data.business && row.data.corporate ? 'Complete' : 'Incomplete';
  };

  const formatData = row => {
    return [
      modalLink('Inputs', 'Inputs', row.input, row.id),
      modalLink('Outputs', 'Outputs', row.data, row.id),
    ];
  };

  const rows = (records || []).map(row => {
    return {
      date: row.createdAt,
      lexisId: formatLexisId(row),
      loginId: row.loginId,
      source: row.source,
      businessStatus: formatBusinessStatus(row),
      processStatus: formatProcessStatus(row),
      data: formatData(row),
    };
  });

  const columns = [
    {
      field: 'date',
      label: 'Date & Time',
      value: ({ date }) => formatDate(date),
    },
    { field: 'lexisId', label: 'LexisNexis IDs' },
    { field: 'loginId', label: 'User Okta ID' },
    { field: 'source' },
    { field: 'businessStatus', label: 'Status of Business' },
    { field: 'processStatus', label: 'Status of Process' },
    { field: 'data', label: 'All ID Info' },
  ];

  return (
    <>
      <DataTable
        transparent
        columns={columns}
        data={rows}
        pageSize={5}
        sort="date"
        order="desc"
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <Modal.Title>{modalData.label}</Modal.Title>
        <Modal.Content>
          <pre>{JSON.stringify(modalData.data, null, 2)}</pre>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default LexisLog;
